import { request } from '../core';
import { Method } from '../core/util';
import { CommonEnumKey } from '@/utils/enum';
import { CommonResponse, EnumListMap } from '@/utils/types';

/**
 * 公共接口类
 * @class CommonFetchApi
 * @extends {BaseOptions}
 */
class CommonFetchApi {
  /**
   * 获取枚举列表映射接口
   * @param {CommonEnumKey[]} keyList
   * @return {*}  {Promise<CommonResponse<EnumListMap>>}
   * @memberof CommonFetchApi
   */
  public getEnumListMap(
    keyList: CommonEnumKey[]
  ): Promise<CommonResponse<EnumListMap>> {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/enum/get_enum_list_map',
      body: { keyList },
    };
    return request(requestParam);
  }
}

export const commonFetchApi = new CommonFetchApi();
